module.exports = __webpack_public_path__ + "static/media/spaced-repetition-main.603eb300.png";